// src/components/MonacoEditorComponent.js
import React, { useEffect, useRef, useState } from 'react';
import Editor from '@monaco-editor/react';
import { diffLines } from 'diff';
import PropTypes from 'prop-types';
import '../App.css'; // Import the CSS file
import { DiffEditor } from '@monaco-editor/react'; // Import DiffEditor

const MonacoEditorComponent = ({
  language = 'javascript',
  value,
  previousValue = '',
  saveFile,
  theme = 'customTheme',
  onMount,
  height = '100%',
  options = {},
  isApply,
  onAccept,
  setCode,
}) => {
  const editorRef = useRef(null);
  const decorationsRef = useRef([]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 's') {
        event.preventDefault();
        const currentValue = editorRef.current.getValue();
        setCode(currentValue);
        saveFile(currentValue);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [setCode, saveFile]);

  return (
    <div style={{ position: 'relative', height }}>
      {isApply ? (
        <>
          <DiffEditor
            height={height}
            language={language}
            original={previousValue}
            modified={value}
            theme={theme}
            loading={null}
            onMount={(editor, monaco) => {
              editorRef.current = editor;
              if (onMount) onMount(editor, monaco);
            }}
            options={{
              scrollBeyondLastLine: true,
              ...options,
            }}
          />
          <button 
            onClick={() => {
              onAccept(false);
              saveFile(value);
            }} 
            style={{
              position: 'absolute',
              top: '10px',
              right: '45px',
              zIndex: 10,
              padding: '10px 20px',
              backgroundColor: '#333',
              color: '#fff',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#555'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#333'}
          >
            Accept
          </button>
          <button 
            onClick={() => {
              onAccept(false);
              setCode(previousValue);
            }} 
            style={{
              position: 'absolute',
              top: '10px',
              right: '140px',
              zIndex: 10,
              padding: '10px 20px',
              backgroundColor: '#333',
              color: '#fff',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#555'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#333'}
          >
            Cancel
          </button>
        </>
      ) : (
        <Editor
          height={height}
          language={language}
          value={value}
          theme={theme}
          loading={null}
          onMount={(editor, monaco) => {
            editorRef.current = editor;
            if (onMount) onMount(editor, monaco);
          }}
          options={{
            scrollBeyondLastLine: true,
            ...options,
          }}
        />
      )}
    </div>
  );
};

export default MonacoEditorComponent;
